import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/App.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";

import configureStore from "./store/store";

import { domain, version } from "./store/actions/apiURL";
const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<Provider store={reduxStore}>
			<App />
			{domain !== "live" && (
				<div
					style={{
						backgroundColor: version === "v2" ? "#ff0000" : "#ea611c",
						position: "fixed",
						borderRadius: "4rem",
						textAlign: "center",
						width: "40vw",
						color: "#fff",
						fontWeight: "700",
						left: "30vw",
						bottom: "0",
						fontSize: 20,
						padding: 12,
						marginBottom: "1.5rem",
						zIndex: 10,
					}}
				>
					{version === "v2"
						? "WARNING: You are connected to the live API"
						: `You are currently on the ${domain} version of Buddy`}
				</div>
			)}
		</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
